import {
    GET_VLAN_POOL,
    GET_VLAN_POOL_SUCCESS,
    GET_VLAN_POOL_FAIL,
} from '../../constants/globalProfileConstants/vlanPoolConstants';

/**
 * Reducer function for managing VLAN Pool list state.
 *
 * This reducer handles actions related to fetching vlan pool data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the vlan pool list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const vlanPoolListReducer = (state = { vlanPoolList: {} }, action) => {
    switch (action.type) {
        case GET_VLAN_POOL:
            return {
                loading: true,
            };
        case GET_VLAN_POOL_SUCCESS:
            return {
                loading: false,
                vlanPoolList: action.payload,
            };
        case GET_VLAN_POOL_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
